import { Component } from '@angular/core';

@Component({
    selector: 'app-common-page-not-found',
    template: '<p><b>404</b> - The requested content does not exist.</p>',
    standalone: false
})
export class PageNotFoundComponent {

}
